import {
  AllLoans as SharedAllLoans,
  ProcessingLoans as SharedProcessingLoans,
  ApprovedLoans as SharedApprovedLoans,
  DisbursedLoans as SharedDisbursedLoans,
  RejectedLoans as SharedRejectedLoans,
  HoldLoans as SharedHoldLoans,
} from '../admin/LoansManagement';

export const EmployeeLoans = () => <SharedAllLoans />;
export const ProcessingLoans = () => <SharedProcessingLoans />;
export const ApprovedLoans = () => <SharedApprovedLoans />;
export const DisbursedLoans = () => <SharedDisbursedLoans />;
export const RejectedLoans = () => <SharedRejectedLoans />;
export const HoldLoans = () => <SharedHoldLoans />;

export default EmployeeLoans;
